/** The look of text inputs (shared by Input, MoneyInput and PasswordInput). */
export const inputClass = [
  'field-focus min-h-11 w-full rounded-md border border-border bg-surface-sunken px-3 text-base text-text shadow-sunken transition-[border-color,box-shadow] duration-[var(--dur-fast)] placeholder:text-text-4',
  'aria-invalid:border-danger',
  'disabled:cursor-not-allowed disabled:bg-surface-3 disabled:text-text-4',
];

/** Textareas and selects. */
export const controlClass =
  'field-focus w-full rounded-md border border-border bg-surface-sunken px-3 text-base text-text shadow-sunken transition-[border-color,box-shadow] duration-[var(--dur-fast)] placeholder:text-text-4 aria-invalid:border-danger';

/** What a Field hands its control: its id and the screen-reader wiring. */
export interface FieldA11y {
  id: string;
  'aria-invalid': boolean;
  'aria-describedby'?: string;
}
